import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IApiResult } from '../shared/models/api-result';
import { ApiUrlProvider } from './api-url.provider';
import { Resource } from '../shared/models/resource';
import { IRosterCode } from '../shared/models/roster-code';
import { IHoliday } from '../shared/models/holiday';

@Injectable({
  providedIn: 'root'
})
export class HolidayService {
  constructor(private http: HttpClient, private apiUrlProvider: ApiUrlProvider) { }
  
  getAll(): Observable<IApiResult<IHoliday[]>>{
    return this.http.get<IApiResult<IHoliday[]>>(`${this.apiUrlProvider.url}/holiday`);
  }

  add(entity: IHoliday): Observable<IApiResult<IHoliday>>{
    return this.http.post<IApiResult<IHoliday>>(`${this.apiUrlProvider.url}/holiday`, entity);
  }

  update(entity: IHoliday): Observable<IApiResult<IHoliday>>{
    return this.http.post<IApiResult<IHoliday>>(`${this.apiUrlProvider.url}/holiday/${entity.id}`, entity);
  }

  delete(entityId: number): Observable<IApiResult<string>>{
    return this.http.post<IApiResult<string>>(`${this.apiUrlProvider.url}/holiday/${entityId}/delete`, null);
  }
}
